/**
 * Implements some of Dashboard APIs
 */
window.DashboardAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsCoreServersBaseURL : publicConfiguration.APIServerBaseURL);

    //Job Type Constants
    self.JOB_PUBLISHED_ARCHIVED = 'PUBLISHED-ARCHIVED';
    self.JOB_EXPIRED_ARCHIVED = 'Expired-ARCHIVED';
    self.JOB_FILLED_ARCHIVED = 'FILLED-ARCHIVED';
    self.JOB_DRAFT_ARCHIVED = 'DRAFT-ARCHIVED';
    self.JOB_PAUSED_ARCHIVED = 'PAUSED-ARCHIVED';
    self.JOB_DRAFT = 'DRAFT';
    self.JOB_FILLED = 'FILLED';
    self.JOB_EXPIRED = 'Expired';
    self.JOB_PUBLISHED = 'PUBLISHED';
    self.JOP_PAUSED = 'PAUSED';
    self.JOP_PENDING_APPROVAL = 'PENDING_APPROVAL';
    self.JOP_APPROVED = 'APPROVED';

    /* Number of days a job will be promoted */
    self.JOB_DAYS_PROMOTING = 30;

    //Job Change State
    self.JOB_CHANGE_UN_ARCHIVE = 'unarchive';
    self.JOB_CHANGE_FILL = 'fill';
    self.JOB_CHANGE_ARCHIVE = 'archive';

    // Response Rate and Profile Strength Codes
    self.WEAK           = 1;
    self.GOOD           = 2;
    self.MODERATE       = 3;
    self.OUTSTANDING    = 4;

    var ITEM_EDIT_MAP = {
        'profile_photo' : {
            title       : $filter('translate')('add profile photo'),
            url         : './edit/profile/media',
            icon        : 'plus-circle'
        },
        'cover_photo' : {
            title       : $filter('translate')('add cover photo'),
            url         : './edit/profile/media',
            icon        : 'plus-circle'
        },
        'bio' : {
            title       : $filter('translate')('update bio'),
            url         : './edit/profile/about',
            icon        : 'pencil'
        },
        'words' : {
            title       : $filter('translate')('update 3 words'),
            url         : './edit/profile/about',
            icon        : 'pencil'
        },
        'education' : {
            title       : $filter('translate')('update education'),
            url         : './edit/profile/education',
            icon        : 'pencil'
        },
        'availability' : {
            title       : $filter('translate')('update availability'),
            url         : './edit/profile/schedule',
            icon        : 'pencil'
        },
        'references' : {
            title       : $filter('translate')('add references'),
            url         : './edit/profile/references',
            icon        : 'plus-circle'
        },
        'work_history' : {
            title       : $filter('translate')('update experience'),
            url         : './edit/profile/work_history',
            icon        : 'pencil'
        },
        'skills' : {
            title       : $filter('translate')('add skills'),
            url         : './edit/profile/skills',
            icon        : 'plus-circle'
        }
    };

    self.getProfileStrength = function() {
        var deferred = $q.defer();

        _protected.request('js_dashboard/profile_strength', 'GET').then(function(res) {
            if (!res.data || !res.data.data || res.data.status_code != 200) {
                return deferred.reject(res);
            }

            var result = {};
            result.profStrength = parseInt(res.data.data.profile_strength);
            result.missingItems = [];

            result.items_list = res.data.data.profile_missing_items || [];
            result.items_list.forEach(function(item) {
                result.missingItems.push(ITEM_EDIT_MAP[item]);
            });

            if (result.profStrength >= 80) {
                result.code = self.OUTSTANDING;
            }
            else if (result.profStrength > 60) {
                result.code = self.GOOD;
            }
            else if (result.profStrength > 40) {
                result.code = self.MODERATE;
            }
            else {
                result.code = self.WEAK;
            }

            deferred.resolve(result);
        });

        return deferred.promise;
    }

    self.getResponseRate = function() {
        var deferred = $q.defer();

        _protected.request('js_dashboard/response_rate', 'GET').then(function(res) {
            if (!res.data || !res.data.data || res.data.status_code != 200) {
                return deferred.reject(res);
            }

            var result = {};
            result.percentage = parseFloat(res.data.data.response_rate_percentage);

            if (result.percentage >= 80) {
                result.statusText = $filter('translate')('outstanding');
                result.code = self.OUTSTANDING;
            }
            else if (result.percentage >= 70) {
                result.statusText = $filter('translate')('good');
                result.code = self.GOOD;
            }
            else {
                result.statusText = $filter('translate')('weak');
                result.code = self.WEAK;
            }

            deferred.resolve(result);
        });

        return deferred.promise;
    }

    self.getTopMembers = function() {
        var deferred = $q.defer();

        _protected.request('js_dashboard/top_members', 'GET').then(function(res) {
            deferred.resolve(res.data.data);
        });

        return deferred.promise;
    }

    //change job status
    self.changeJobStatus = function(jobId,toStatus, filledOn) {
        var defer = $q.defer();

        var requestPayload = {
            'job_id' : jobId,
            'action' : toStatus
        };

        if (filledOn) {
            var date = new Date(filledOn);
            date.setHours(0);
            requestPayload['filled_on'] = moment(date).locale("en").format('ddd, DD MMM YYYY');
        }

        _protected.request(`${self.apiUrl.replace('v1', 'v2')}jobs/changeStatus`, 'POST', requestPayload).then((result) => {
            if(result && result.data && result.data.status_code == 200){
                defer.resolve();
            }else{
                defer.reject(result);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    }
    /* Get Brand Jobs */
    self.getBrandJobs = function(brandId,filter, assigneeId, payload) {
      var deferred = $q.defer();
      var apiUrl = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? environmentsConfig.get('tsCoreServers') : environmentsConfig.get('coreReaderAPIServers');

      payload = payload || {};
      payload['assignee_id'] = assigneeId;

      _protected.request(apiUrl +"jobs/job_view/"+brandId+"/"+filter, 'GET', payload).then(function(res) {
        if(res && res.data && res.data.data && res.data.data.Jobs && res.data.data.Jobs.length>0){

          var resultJobs = res.data.data.Jobs;

          var jobs = [];
          for(var i in resultJobs){
            var job = {};
            job = resultJobs[i].Job;

            //add job type
            if(job.JobType && job.JobType[0]){
                job.jobType = job.JobType[0].name;
                delete(job.JobType);
            }

            //add job position
            if(job.Position && job.Position[0]){
                job.position = job.Position[0];
            }

            //put deafult values for some propreities
            job.number_of_unread = job.number_of_unread || 0;
            job.number_of_applications = job.number_of_applications || 0;
            job.number_of_applicants = job.number_of_applicants || 0;
            job.number_of_proceeds = job.number_of_proceeds || 0;
            job.number_of_interviews = job.number_of_interviews || 0;
            job.number_of_locations = job.number_of_locations || 0;

            //push job to jobs list
            jobs.push(job);
          }
          /*
            @ToDo: add caching
             */
          deferred.resolve(jobs);
        }else{
          deferred.resolve([]);
        }
      });

      return deferred.promise;
    }

    /* Get onBoarding Brand Jobs */
    self.getBrandOnboardingJobs = function(brandId) {
        var deferred = $q.defer();

        _protected.request("jobs/on_boarding/"+brandId, 'GET').then(function(res) {
            if(res && res.data && res.data.data && res.data.data){
                //actual jobs data
                var resultJobs = res.data.data.Jobs;
                //will be resolved
                var jobs = [];

                if(resultJobs){
                    for(var i in resultJobs){
                        var job = {};
                        job = resultJobs[i].Job;

                        //add job type
                        if(job.JobType && job.JobType[0]){
                            job.jobType = job.JobType[0].name;
                            delete(job.JobType);
                        }

                        //add job position
                        if(job.Position && job.Position[0]){
                            job.position = job.Position[0];
                            delete(job.Position);
                        }

                        //put deafult values for some propreities
                        job.number_of_unread = job.number_of_unread || 0;
                        job.number_of_applications = job.number_of_applications || 0;
                        job.number_of_applicants = job.number_of_applicants || 0;
                        job.number_of_proceeds = job.number_of_proceeds || 0;
                        job.number_of_interviews = job.number_of_interviews || 0;
                        job.number_of_locations = job.number_of_locations || 0;
                        job.number_of_offer = resultJobs[i].Job.number_of_offer || 0;
                        job.number_of_on_board = resultJobs[i].Job.number_of_on_board || 0;
                        job.number_of_hired = resultJobs[i].Job.number_of_hired || 0;
                        job.number_of_unread = resultJobs[i].Job.number_of_unread || 0;

                        //push job
                        jobs.push(job);
                    }
                }

                /*
                 @ToDo: add caching
                 */
                deferred.resolve(jobs);
            }else{
                deferred.reject("Error with jobs API");
            }
        });

        return deferred.promise;
    }

    self.getEmployerDashboardData = function (brandId, includeArchived) {
        var deferred = $q.defer();
        var optionalParameter = '';

        if (includeArchived) {
            optionalParameter = '?include_archived=true';
        }
        if (!brandId) {
            throw "no brand id";
        }

        _protected.request("groups/" + brandId + "/employer/dashboard_data" + optionalParameter, 'GET')
            .then(function (res) {
                deferred.resolve(res);
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get Dashboard Data,
     * employer brand list
     */
    self.getEmployerBrandsList = function(groupId, on_boarding, includeArchived){

        var deferred = $q.defer();

        var params = {};

        if(on_boarding){
            params.on_boarding = true;
        }
        if (includeArchived) {
            params.include_archived = includeArchived;
        }

        _protected.request("groups/" + groupId + "/employer/dashboard_data", 'GET', params).then(function(res) {

            //reject
            if (!res || !res.data || !res.data.data || res.data.status_code != 200) {
                return deferred.reject(res);
            }

            var resBrands = res.data.data;
            var brands = [];
            resBrands.forEach(function(resBrand) {

                var brand = {};
                brand = resBrand.Brand[0].Brand;
                //mark top level brands for views
                brand.enterprise = true;
                brand.job_balance = brand.job_balance || 0;

                if(brand.BrandMedia){
                    for (var i in brand.BrandMedia) {
                        brand[brand.BrandMedia[i].type] = brand.BrandMedia[i];
                    }
                }
                delete(brand.BrandMedia);

                if(resBrand.Children){
                    brand.children = [];
                    resBrand.Children.forEach(function(resBrandChild){
                        var childBrand = {};
                        childBrand = resBrandChild.info[0].Brand;
                        childBrand.job_balance = childBrand.job_balance || 0;

                        if(childBrand.BrandMedia){
                            childBrand.BrandMedia.forEach(function(brandMedia){
                                childBrand[brandMedia.type] = brandMedia;
                            })
                        }
                        delete(childBrand.BrandMedia);

                        brand.children.push(childBrand);
                    });
                }

                brands.push(brand);

            });

            //resolve brands
            deferred.resolve(brands);

        }, function (err) {

            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandsHiringDataStats = function (payload, assigneeId, includeArchived) {

        var deferred = $q.defer();

        if (includeArchived) {
            payload.include_archived = includeArchived;
        }

        _protected.uniqueRequest("employer/dashboard_data_stats" + (assigneeId ? ("?assignee_id=" + assigneeId) : ''), 'POST', payload)
            .then(function (result) {

                if (result && result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }

            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get Onboarding Brand Stats
     */
    self.getOnboardingStats = function(brands, includeArchived){

        var deferred = $q.defer();

        var requestPayload = {
            brands: brands,
            include_archived: !!includeArchived
        };

        _protected.request("on_boarding/dashboard_data_stats", 'POST',requestPayload).then(function(result) {

            if(result && result.data && result.data.data){
                deferred.resolve(result.data.data);
            }else{
                deferred.reject(result);
            }

        }, function (err) {

            deferred.reject(err);
        });

        return deferred.promise;
    }


    /**
     * Get Brand Managers
     */
    self.getBrandManagers = function(brands, includeParent, includeImplicit){

        var deferred = $q.defer();

        var requestPayload = {
            brands: brands,
            include_parent: !!includeParent,
            include_implicit: !!includeImplicit,
            include_lower_tree: true
        };

        _protected.request("brand_managers", 'POST',requestPayload).then(function(res) {

            if(res && res.data && res.data.data){
                deferred.resolve(res.data.data);
            }else{
                deferred.reject(res);
            }

        }, function (err) {

            deferred.reject(err);
        });

        return deferred.promise;
    }

    /* Check User Registration */
    self.checkUserRegistration = function(email){

        var deferred = $q.defer();

        _protected.request("non_applicant/verify_by_email", 'GET', { email: email }).then(function(res) {
            if(res && res.data && res.data.data && res.data.data && res.data.status_code == 200){
                deferred.resolve(res.data.data);
            }else{
                deferred.reject(res);
            }
        });

        return deferred.promise;
    };


    self.checkUserRegistrationByPhone = function (phone) {

        var deferred = $q.defer()

        var params = {
            phone: window.intlTelInputUtils.formatNumber(angular.copy(phone))
        }

        _protected.request("non_applicant/verify_by_phone", 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            })

        return deferred.promise;
    };

    self.loadJobCommunicationEmailsUsers = function (jobId) {

        var deferred = $q.defer();

        _protected.request("jobs/" + jobId + "/notification_settings", 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data &&
                    res.data.data.notification_settings &&
                    res.data.data.notification_settings.users &&
                    res.data.status_code == 200)
                    deferred.resolve(res.data.data.notification_settings.users);
                else
                    deferred.reject(res.data)
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobCommunicationEmailsUsers = function (jobId, userIds) {

        var deferred = $q.defer();

        var requestPayload = {
            users: userIds || []
        };

        _protected.request("jobs/" + jobId + "/notification_settings", 'PUT', requestPayload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200)
                    deferred.resolve(res.data.data);
                else
                    deferred.reject(res.data)
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.loadJobReadyToOfferEmailsUsers = function (brandId, jobId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/jobs/" + jobId + "/ready_to_offer/users", 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.ready_to_offer_users && res.data.status_code == 200)
                    deferred.resolve(res.data.data.ready_to_offer_users);
                else
                    deferred.reject(res.data)
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobReadyToOfferEmailsUsers = function (brandId, jobId, userIds) {

        var deferred = $q.defer();

        var requestPayload = {
            ready_to_offer_users: userIds || []
        };

        _protected.request("brands/" + brandId + "/jobs/" + jobId + "/ready_to_offer/users",'PUT', requestPayload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200)
                    deferred.resolve(res.data.data);
                else
                    deferred.reject(res.data)
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
});
